import * as React from "react";
import {none, Option} from "ts-option";
import {default as DropDownList, DropDownItem} from "../../../../hiberUiKit/src/molecules/DropDownList/DropDownList";
import InfoModule from "../../../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import {Icon} from "../../../../hiberUiKit/src/atoms/Icon/Icon";
import DropDownWrapper from "../../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import MarketingAndTrackingModal from "./MarketingAndTrackingModal";
import TextUtils from "../../../../utils/TextUtils";
import TrackingData from "../../../../model/lead/TrackingData";

interface IComponentProps {
	/**
	 * Tracking.
	 */
	tracking: Option<TrackingData>
	/**
	 * On data change callback.
	 * @param {Option<TrackingData>} tracking
	 */
	onChange: (tracking: Option<TrackingData>) => void;
}

interface IState {
	/**
	 * Menu dropdown visibility.
	 */
	menuDropDownVisible: boolean;
	/**
	 * Edit tracking modal visibility.
	 */
	editTrackingVisible: boolean;
}

type Props = IComponentProps

export class MarketingAndTracking extends React.PureComponent<Props, IState> {
	filedTrackingFieldsMenu: DropDownItem[] = [
		{id: "l1", label: "Change"},
		{id: "l2", label: "Remove"},
		{id: "l3", label: "Copy"},
	];

	emptyTrackingFieldsMenu: DropDownItem[] = [
		{id: "l1", label: "Change"}
	];

	constructor(props: Props) {
		super(props);
		this.state = {menuDropDownVisible: false, editTrackingVisible: false};
		this.toggleMenu = this.toggleMenu.bind(this);
		this.onMenuItemSelect = this.onMenuItemSelect.bind(this);
		this.onChange = this.onChange.bind(this);
	}

	render() {
		const trackingFieldsExist = this.props.tracking.map(t => !t.isEmpty()).getOrElse(false);

		const menuItems = trackingFieldsExist ? this.filedTrackingFieldsMenu : this.emptyTrackingFieldsMenu;
		return (
			<InfoModule icon={Icon.New} title={"Inbound Marketing & Tracking"} actionIcon={Icon.Overflow}
						onActionIconClick={this.toggleMenu}>
				{this.state.menuDropDownVisible &&
				<DropDownWrapper onOutsideClick={() => this.setState({menuDropDownVisible: false})}>
					<DropDownList items={menuItems}
								  itemToId={(link: DropDownItem) => link.id}
								  itemToLabel={(link: DropDownItem) => link.label}
								  onSelect={this.onMenuItemSelect}/>
				</DropDownWrapper>}
				{this.state.editTrackingVisible &&
				<MarketingAndTrackingModal tracking={this.props.tracking}
										   onClose={() => {this.setState({editTrackingVisible: false})}}
										   onChange={this.onChange}/>}
				{trackingFieldsExist ?
					this.props.tracking.map(t => {
							return (
								<ul className={"c-info-common-list"}>
									{t.campaign.map(c => {return (<li className={"t-body"}>Campaign: {c}</li>)}).orNull}
									{t.source.map(s => {return (<li className={"t-body"}>Source: {s}</li>)}).orNull}
									{t.adGroup.map(ad => {return (<li className={"t-body"}>Ad Group: {ad}</li>)}).orNull}
									{t.landingPage.map(lp => {return (<li className={"t-body"}>Landing Page:<br/>{lp}</li>)}).orNull}
									{t.url.map(u => {return (<li className={"t-body"}>URL:<br/>{u}</li>)}).orNull}
								</ul>)
						}
					).get :
					<span className={"t-body"}>No marketing details</span>
				}
			</InfoModule>
		);
	}

	onMenuItemSelect(item: DropDownItem) {
		this.setState({menuDropDownVisible: false});
		switch (item.id) {
			case "l1":
				this.setState({menuDropDownVisible: false, editTrackingVisible: true});
				break;
			case "l2":
				this.setState({menuDropDownVisible: false}, () => {this.props.onChange(none)});
				break;
			case "l3":
				this.props.tracking.map(t => TextUtils.copyToClipboard(t.getText()));
				break;
		}
	}

	toggleMenu() {
		this.setState({menuDropDownVisible: !this.state.menuDropDownVisible})
	}

	onChange(tracking: Option<TrackingData>) {
		this.setState({editTrackingVisible: false}, () => this.props.onChange(tracking));
	}
}
